<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-start d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
    <a class="ms-25" href="https://1.envato.market/pixinvent_portfolio" target="_blank">Pixinvent</a>
    <span class="d-none d-sm-inline-block">, All rights Reserved</span>
  </span>
  <span class="float-md-end d-none d-md-block">
    Hand-crafted & Made with <span [data-feather]="'heart'" [class]="'pink'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
@if (coreConfig.layout.scrollTop) {
  <app-scroll-top></app-scroll-top>
}
